//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'frozen-rose',
    colors: ['#29368f', '#e9697b', '#1b164d', '#f7d996'],
    background: '#f2e8e4',
    type: 'golid',
  },
  {
    name: 'winter-night',
    colors: ['#122438', '#dd672e', '#87c7ca', '#ebebeb'],
    background: '#ebebeb',
    type: 'golid',
  },
  {
    name: 'saami',
    colors: ['#eab700', '#e64818', '#2c6393', '#eecfca'],
    background: '#e7e6e4',
    type: 'golid',
  },
  {
    name: 'knotberry1',
    colors: ['#20342a', '#f74713', '#686d2c', '#e9b4a6'],
    background: '#e5ded8',
    type: 'golid',
  },
  {
    name: 'knotberry2',
    colors: ['#1d3b1a', '#eb4b11', '#e5bc00', '#f29881'],
    background: '#eae2d0',
    type: 'golid',
  },
  {
    name: 'tricolor',
    colors: ['#ec643b', '#56b7ab', '#f8cb57', '#1f1e43'],
    background: '#f7f2df',
    type: 'golid',
  },
  {
    name: 'foxshelter',
    colors: ['#ff3931', '#007861', '#311f27', '#bab9a4'],
    background: '#dddddd',
    type: 'golid',
  },
  {
    name: 'hermes',
    colors: ['#253852', '#51222f', '#b53435', '#ecbb51'],
    background: '#eeccc2',
    type: 'golid',
  },
  {
    name: 'olympia',
    colors: ['#ff3250', '#ffb33a', '#008c36', '#0085c6', '#4c4c4c'],
    stroke: '#0b0b0b',
    background: '#faf2e5',
    type: 'golid',
  },
  {
    name: 'byrnes',
    colors: ['#c54514', '#dca215', '#23507f'],
    stroke: '#0b0b0b',
    background: '#e8e7d4',
    type: 'golid',
  },
  {
    name: 'butterfly',
    colors: ['#f40104', '#f6c0b3', '#99673a', '#f0f1f4'],
    stroke: '#191e36',
    background: '#191e36',
    type: 'golid',
  },
  {
    name: 'floratopia',
    colors: ['#bf4a2b', '#cd902a', '#4e4973', '#f5d4bc'],
    stroke: '#1e1a43',
    background: '#1e1a43',
    type: 'golid',
  },
  {
    name: 'verena',
    colors: ['#f1594a', '#f5b50e', '#14a160', '#2969de', '#885fa4'],
    stroke: '#1a1a1a',
    background: '#e2e6e8',
    type: 'golid',
  },
  {
    name: 'florida_citrus',
    colors: ['#ea7251', '#ebf7f0', '#02aca5'],
    stroke: '#050100',
    background: '#9ae2d3',
    type: 'golid',
  },
  {
    name: 'lemon_citrus',
    colors: ['#e2d574', '#f1f4f7', '#69c5ab'],
    stroke: '#463231',
    background: '#f79eac',
    type: 'golid',
  },
  {
    name: 'yuma_punk',
    colors: ['#f05e3b', '#ebdec4', '#ffdb00'],
    stroke: '#ebdec4',
    background: '#161616',
    type: 'golid',
  },
  {
    name: 'yuma_punk2',
    colors: ['#f2d002', '#f7f5e1', '#ec643b'],
    stroke: '#19080e',
    background: '#f7f5e1',
    type: 'golid',
  },
  {
    name: 'moir',
    colors: ['#a49f4f', '#d4501e', '#f7c558', '#ebbaa6'],
    stroke: '#161716',
    background: '#f7f4ef',
    type: 'golid',
  },
  {
    name: 'sprague',
    colors: ['#ec2f28', '#f8cd28', '#1e95bb', '#fbaab3', '#fcefdf'],
    stroke: '#221e1f',
    background: '#fcefdf',
    type: 'golid',
  },
  {
    name: 'bloomberg',
    colors: ['#ff5500', '#f4c145', '#144714', '#2f04fc', '#e276af'],
    stroke: '#000',
    background: '#fff3dd',
    type: 'golid',
  },
  {
    name: 'revolucion',
    colors: ['#ed555d', '#fffcc9', '#41b797', '#eda126', '#7b5770'],
    stroke: '#fffcc9',
    background: '#2d1922',
    type: 'golid',
  },
  {
    name: 'sneaker',
    colors: ['#e8165b', '#401e38', '#66c3b4', '#ee7724', '#584098'],
    stroke: '#401e38',
    background: '#ffffff',
    type: 'golid',
  },
  {
    name: 'miradors',
    colors: ['#ff6936', '#fddc3f', '#0075ca', '#00bb70'],
    stroke: '#ffffff',
    background: '#020202',
    type: 'golid',
  },
  {
    name: 'kaffeprat',
    colors: ['#BCAA8C', '#D8CDBE', '#484A42', '#746B58', '#9A8C73'],
    stroke: '#000',
    background: '#fff',
    type: 'golid',
  },
  {
    name: 'jrmy',
    colors: ['#df456c', '#ea6a82', '#270b32', '#471e43'],
    stroke: '#270b32',
    background: '#ef9198',
    type: 'golid',
  },
  {
    name: 'animo',
    colors: ['#f6c103', '#f6f6f6', '#d1cdc7', '#e7e6e5'],
    stroke: '#010001',
    background: '#f5f5f5',
    type: 'golid',
  },
  {
    name: 'book',
    colors: ['#be1c24', '#d1a082', '#037b68', '#d8b1a5', '#1c2738', '#c95a3f'],
    stroke: '#0e0f27',
    background: '#f5b28a',
    type: 'golid',
  },
  {
    name: 'juxtapoz',
    colors: ['#20357e', '#f44242', '#ffffff'],
    stroke: '#000000',
    background: '#cfc398',
    type: 'golid',
  },
  {
    name: 'hurdles',
    colors: ['#e16503', '#dc9a0f', '#dfe2b4', '#66a7a6'],
    stroke: '#3c1c03',
    background: '#3c1c03',
    type: 'golid',
  },
  {
    name: 'ludo',
    colors: ['#df302f', '#e5a320', '#0466b3', '#0f7963'],
    stroke: '#272621',
    background: '#dedccd',
    type: 'golid',
  },
  {
    name: 'riff',
    colors: ['#e24724', '#c7c7c7', '#1f3e7c', '#d29294', '#010203'],
    stroke: '#010203',
    background: '#f2f2f2',
    type: 'golid',
  },
  {
    name: 'san ramon',
    colors: ['#4f423a', '#f6a74b', '#589286', '#f8e9e2', '#2c2825'],
    stroke: '#2c2825',
    background: '#fff',
    type: 'golid',
  },
  {
    name: 'one-dress',
    colors: ['#1767D2', '#FFFFFF', '#F9AB00', '#212121'],
    stroke: '#212121',
    background: '#fff',
    type: 'golid',
  },
];
